export const avatarDiameter = '60px';
export const marginRightTrendingCard = '40px';
